import * as React from "react";
import { Button } from "@fluentui/react-components";
import { useIconPickerStyles } from "./iconPickerStyles";

interface Props {
  isInserting: boolean;
  selectedCount: number;
  onInsert: () => void;
}

const IconPickerInsertBar: React.FC<Props> = ({ isInserting, selectedCount, onInsert }) => {
  const styles = useIconPickerStyles();

  return (
    <div className={styles.footer}>
      <Button appearance="primary" className={styles.insertButton} disabled={selectedCount === 0 || isInserting} onClick={onInsert}>
        {isInserting
          ? "Inserting icons..."
          : selectedCount === 0
            ? "Select icons to insert"
            : `Insert ${selectedCount} icon${selectedCount > 1 ? "s" : ""}`}
      </Button>
    </div>
  );
};

export default IconPickerInsertBar;
